export default __webpack_public_path__ + "static/media/email-inactive.47192d39.svg";